import { render, staticRenderFns } from "./OrdersForm.vue?vue&type=template&id=a6903a52"
import script from "./OrdersForm.vue?vue&type=script&lang=js"
export * from "./OrdersForm.vue?vue&type=script&lang=js"
import style0 from "./OrdersForm.vue?vue&type=style&index=0&id=a6903a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports